import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useCreateClient } from '@/hooks/useClients';
import { ClientForm } from '@/components/clients/ClientForm';
import type { Client, ClientInput } from '@jobos/shared/types/client';

interface AddClientModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClientCreated: (client: Client) => void;
}

export function AddClientModal({ open, onOpenChange, onClientCreated }: AddClientModalProps) {
  const { mutateAsync: createClient, isPending } = useCreateClient();

  const handleSubmit = async (data: ClientInput) => {
    try {
      const client = await createClient(data);
      onClientCreated(client);
      onOpenChange(false);
    } catch (error) {
      // error handling handled by hook toast; keep modal open for retry
      console.error('Failed to create client:', error);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Add New Client</DialogTitle>
        </DialogHeader>
        <ClientForm
          onSubmit={handleSubmit}
          isPending={isPending}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
